import React, { useEffect, useState } from 'react';
import "./SpaCard.css";
import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../../common/baseUrl';
import { getImageUrl, peekImageUrl } from '../../../../common/imageUrl';

export default function SpaCard(props) {

  const [quantity, setQuantity] = useState(0); // State to track quantity
  // Seeded from the shared cache, which is keyed on the photo and expires,
  // rather than a per-id sessionStorage entry that was never invalidated.
  const [imageUrl, setImageUrl] = useState(() => peekImageUrl(props.photo) || "");
  const [loading, setLoading] = useState(!imageUrl); // State to track loading

  // This for Image
  useEffect(() => {
    let isCancelled = false;

    getImageUrl(props.photo)
      .then((url) => {
        if (isCancelled) {
          return;
        }

        if (url) {
          setImageUrl(url);
        }

        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching image:", error);

        if (!isCancelled) {
          setImageUrl(null);
          setLoading(false);
        }
      });

    return () => {
      isCancelled = true;
    };
  }, [props.photo]);

 

  // THis is for setting the quantity if go to final page and then come to this page
  useEffect(() => {
    if (props.spaCart.length > 0) {
        const currentItem = props.spaCart.find(item => item.spa_service_id === props.id);
        if (currentItem) {
          setQuantity(currentItem.quantity); // Set the quantity for the current food item
        }
    }
  },[props.spaCart,props.id])


  // Add to Cart Functionality
  const handleAddToCart = () => {
    const itemInCart = props.spaCart.find(item => item.spa_service_id === props.id);
  

    if (itemInCart) {
      console.log("Item already present in the cart");
    } else {

      console.log("Spa Cart Length : " + props.spaCart.length)  
      if(props.spaCart.length>=1){ 
        toast.error("Only One Spa Service Can be Selected")
        return;
      }  
      setQuantity(1);
      props.setSpaCart([
        ...props.spaCart,
        {
          spa_service_id: props.id,
          name: props.name,
          quantity: 1, // Set the initial quantity to 1
          price: props.price
        },
      ]); 

    }
  };

  // Increase quantity
  // const handleIncreaseQuantity = () => {
  //   const newQuantity = quantity + 1;
  //   setQuantity(newQuantity);
  //   updateCartItemQuantity(props.id, newQuantity);
  // };

  // Decrease quantity
  const handleRemoveFromCart = () => {
    if (quantity > 0) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      updateCartItemQuantity(props.id, newQuantity);
    }
  };


  // Update quantity in the cart
  const updateCartItemQuantity = (id, newQuantity) => {
    if (newQuantity === 0) {
      const updatedCart = props.spaCart.filter(item => item.spa_service_id !== id);
      props.setSpaCart(updatedCart);
    } else {
      const updatedCart = props.spaCart.map(item =>
        item.spa_service_id === id ? { ...item, quantity: newQuantity } : item
      );
      props.setSpaCart(updatedCart);
    }
  };

  return (
    <div className="spa-data">
      <div className="spa-card">
        <div className="spa-card-header">
          <h3>{props.name}</h3>
          <h5>{props.price} ₹</h5>
          <p>{props.desc}</p>
          {/* Cancel Button */}
          <div className="spa-remove-btn">
            {
              !(quantity<=0) && <button onClick={handleRemoveFromCart} >Remove Spa Service</button>
            }
          </div>
        </div>

        {/* Spa Card Img */}
        <div className="spa-card-img">
          {loading ? (
            // Show shimmer effect while the image is loading
            <div className="skeleton"></div>
          ) : (
           
            <img src={imageUrl || props?.photo} alt={props.name || "Spa"} />
         
          )}
          
          

          {quantity <= 0 ? (
            <button className="add-btn" onClick={handleAddToCart}>
              Add
            </button>
          ) : (
            <div className="spa-btn-qty">
              {/* <button className="minus" onClick={handleRemoveFromCart}>
                -
              </button> */}
              {/* <button className="qtyNum">{quantity}</button> */}
              {/* <button className="plus" onClick={handleIncreaseQuantity}>
                +
              </button> */}
            </div>
          )}
        </div>



      </div>
    </div>
  );
}
